import React from "react";

interface IndustryHeaderProps {
  title: React.ReactNode;
  subtitle: string;
  description: string;
  mode?: "light" | "dark";
  btnwidth?: number;
  classname?: string;
  button: React.ReactNode;
}

export default function IndustryHeader({
  title,
  subtitle,
  description,
  mode = "light",
  classname = "",
  button,
}: IndustryHeaderProps) {
  return (
    <div
      className={`w-full ${mode === "light" ? "2xl:pt-[80px] pt-[20px]" : "bg-transparent"}  2xl:pb-[40px] pb-[30px] ${classname}`}
    >
      <div
        className={`max-w-[2500px] mx-auto ${mode === "light" ? "w-[calc(100%_-_10%)]" : "w-full"}`}
      >
        <div className="flex flex-col">
          {/* Subtitle */}
          <p
            className={`text-base font-medium uppercase tracking-tight 
          ${mode === "light" ? "text-[#00040B]" : "text-white"} mb-[20px] border-b
           border-[#636364]/20 pb-[10px]`}
          >
            {subtitle}
          </p>

          {/* Main content row */}
          <div className="flex flex-col lg:flex-row justify-between items-start">
            <div className="max-w-full lg:max-w-[70%] lg:mb-0">
              {/* Title */}
              <h2
                className={`text-[length:var(--industry-header-title)] font-medium clash-font leading-[1.1]
               ${mode === "light" ? "text-black" : "text-white"} mb-[30px]`}
              >
                {title}
              </h2>

              {/* Description */}
              <p className="text-[length:var(--industry-para)] leading-[1.7] text-gray-600 max-w-[90%] lg:max-w-[80%]">
                {description}
              </p>
            </div>

            {/* Button */}
            {button}
          </div>
        </div>
      </div>
    </div>
  );
}
